/* tslint:disable */
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { TokenModel } from '../../models/token-model';
import { UserEmailChangeConfirmModel } from '../../models/user-email-change-confirm-model';

export interface UserEmailChangeConfirmPostParams {
  userGuid: string;
  body: UserEmailChangeConfirmModel;
}

export function userEmailChangeConfirmPost(
  http: HttpClient,
  rootUrl: string,
  params: UserEmailChangeConfirmPostParams,
  headers: HttpHeaders,
  context?: HttpContext,
): Observable<StrictHttpResponse<TokenModel>> {
  const rb = new RequestBuilder(
    rootUrl,
    userEmailChangeConfirmPost.PATH,
    'post',
  );

  for (const headerKey of headers.keys()) {
    rb.header(headerKey, headers.get(headerKey));
  }

  rb.path('userGuid', params.userGuid, { style: 'simple' });
  rb.body(params.body, 'application/json');

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter(
        (r: unknown): r is HttpResponse<unknown> => r instanceof HttpResponse,
      ),
      map((r: HttpResponse<unknown>) => {
        return r as StrictHttpResponse<TokenModel>;
      }),
    );
}

userEmailChangeConfirmPost.PATH =
  '/api/v1/users/{userGuid}/email-change/confirm';
